/** Mock preview for /agents — demo agent + local chat without backend. */
export function isAgentsMockMode(search?: { readonly mock?: string | undefined }): boolean {
  if (search?.mock === "0") return false;
  if (search?.mock === "1") return true;
  if (import.meta.env.DEV) return true;
  if (typeof window !== "undefined") {
    try {
      return window.localStorage.getItem("morrow-agents-mock") === "1";
    } catch {
      return false;
    }
  }
  return false;
}
